/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import './style.scss';
import PropTypes from 'prop-types';

import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import {
  Box,
  darken,
  lighten,
  useTheme,
  Tooltip,
  IconButton,
} from '@mui/material';

import { ReactComponent as Delete } from 'src/assets/icons/trash.svg';

export default function CustosTable({ config, data, handleDelete }) {
  const columns = useMemo(
    () => [
      /*{
        header: 'id',
        accessorKey: 'uid',
        enableEditing: false,
      },*/
      {
        id: 'delete',
        header: 'Deletar',
        enableEditing: false,
        grow: false,
        Cell: ({ row }) => (
          <Box className="deleteCell" sx={{ display: 'flex', gap: '1rem' }}>
            <Tooltip title="Deletar">
              <IconButton onClick={() => handleDelete?.(row)}>
                <Delete className="tableIcon line" />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
      {
        header: 'Cod. Centro de Custos',
        accessorKey: 'codccu',
        enableEditing: false,
      },
      {
        header: 'Descrição',
        accessorKey: 'desc',
        enableEditing: false,
      },
      {
        header: 'Valor',
        accessorKey: 'valor',
        enableEditing: true,
      },
    ],
    []
  );

  const contasTable = useMaterialReactTable({
    columns,
    data,
    ...config,
  });

  return <MaterialReactTable table={contasTable} />;
}

CustosTable.propTypes = {
  config: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
};
